import { Link } from "react-router-dom";
import Logo from "../assets/mb_mailer.png";
import WhyMBMailer from "../components/whyMBMailer";

export default function HomePage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-500 to-purple-600 text-white text-center p-6">
      <div className="w-[15%]">
        <img src={Logo} alt="" />
      </div>
      <h1 className="text-4xl font-bold mb-4">Welcome to MBMailer</h1>
      <p className="text-lg mb-6 max-w-xl">
        A secure and scalable email form service. Power your website forms with
        API-key protected email delivery — no backend needed.
      </p>
      <section>
        <WhyMBMailer />
      </section>
      <Link
        to="/signup"
        className="px-6 py-3 bg-white text-blue-600 font-semibold rounded-lg shadow hover:bg-gray-100 transition"
      >
        Get Started
      </Link>
    </div>
  );
}
